/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Client from 'fierry/flux/entity/client';

import Server from 'shared/query/galaxy';

import State from 'galax/state/map/offset';

import Screen from 'shared/client/screen';
import Geometry from 'galax/client/geometry/galaxy';

import * as Coords from 'shared/geo/coords';


export default new Client ([ State, Geometry, Screen, Server ], class
{
  constructor ([ state, dispatch ], geometry, screen, server)
  {
    this.state = state;
    this.dispatch = dispatch;

    this.geometry = geometry;
    this.screen = screen;
    this.server = server;
  }


  setDnD (value)
  {
    this.dispatch(State.SetDnD, { value });
  }


  setAbsolute (x, y)
  {
    this.dispatch(State.SetAbsolute, { x, y });
  }


  setRelative (dx, dy)
  {
    this.dispatch(State.SetRelative, { dx, dy });
  }


  isDnD ()
  {
    return this.state.dnd;
  }


  getOffset ()
  {
    const { x, y } = this.state;

    const center = this.__getCenterOffset__();

    return { x: x + center.x, y: y + center.y };
  }


  getRange ()
  {
    const { x, y } = this.getOffset();

    const width = this.__getZoneWidth__();
    const height = this.__getZoneHeight__();

    return (
    {
      start:
      {
        x: Math.floor((-x - width / 2) / width),
        y: Math.floor((-y - height / 2) / height),
      },
      end:
      {
        x: Math.ceil((-x + width / 2 + this.__getWindowWidth__()) / width),
        y: Math.ceil((-y + height / 2 + this.__getWindowHeight__()) / height),
      }
    });
  }


  getPixelToCoords (clientX, clientY)
  {
    const xSize = this.geometry.getHex().getExternalSize() * this.geometry.getHex().getStretchX();
    const ySize = this.geometry.getHex().getExternalSize() * this.geometry.getHex().getStretchY();

    const { x, y } = this.getOffset();

    return Coords.fromPixel(clientX - x, clientY - y, xSize, ySize)
  }


  __getCenterOffset__ ()
  {
    const center = this.__getCenterCoords__();

    const width = this.__getZoneWidth__();
    const height = this.__getZoneHeight__();

    const x = Math.round((this.__getWindowWidth__() / 2) - (center.x + 1) * width);
    const y = Math.round((this.__getWindowHeight__() / 2) - (center.y + 1) * height);

    return { x, y };
  }


  __getCenterCoords__ ()
  {
    const coords = this.__getCenterUser__().getCenterCoords();

    return { x: coords.getX(), y: coords.getY() };
  }


  __getCenterUser__ ()
  {
    const currentUser = this.server.getCurrentUser();
    const otherUsers = this.server.getUsers().getAll();

    return currentUser;
  }


  __getZoneWidth__ ()
  {
    return this.geometry.getHex().getHorizontalDistance();
  }


  __getZoneHeight__ ()
  {
    return this.geometry.getHex().getVerticalDistance();
  }


  __getWindowWidth__ ()
  {
    return this.screen.getWindowWidth();
  }


  __getWindowHeight__ ()
  {
    return this.screen.getWindowHeight();
  }


});
